import script from "./HrDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HrDropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./HrDropdownMenu.vue?vue&type=style&index=0&id=19c0dc5c&lang=scss&scoped=true"
import "./HrDropdownMenu.vue?vue&type=style&index=1&id=19c0dc5c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c0dc5c"]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QBtn});
